import React from 'react'
import Alert, { AlertProps } from '@mui/material/Alert'
import Box from '@mui/material/Box'

type MapBubbleContentsErrorProps = {
  message: string
  severity?: AlertProps['severity']
}

function MapBubbleContentsAlert({
  message,
  severity = 'warning',
}: MapBubbleContentsErrorProps) {
  return (
    <Box sx={{ userSelect: 'none' }}>
      <Alert severity={severity} sx={{ mr: 1, alignItems: 'flex-start' }}>
        {message}
      </Alert>
    </Box>
  )
}

export default MapBubbleContentsAlert
